import React, { useState } from "react";

export const Button = ({
  children,
  onClick,
  type = "button",
  variant = "default",
  disabled = false,
  title,
  style = {},
  ...props
}) => {
  const [pressed, setPressed] = useState(false);

  const baseStyle = {
    padding: "6px 12px",
    borderRadius: "4px",
    fontWeight: "bold",
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "all 0.1s ease-in-out",
    transform: pressed && !disabled ? "translateY(2px)" : "translateY(0)",
    boxShadow: pressed && !disabled
      ? "inset 0 2px 4px rgba(0,0,0,0.2)"
      : "0 2px 4px rgba(0,0,0,0.2)",
    opacity: disabled ? 0.6 : 1,
    userSelect: "none",
  };

  const variants = {
    default: { backgroundColor: "#007bff", color: "#fff", border: "none" },
    outline: { backgroundColor: "#fff", color: "#007bff", border: "1px solid #007bff" },
    success: { backgroundColor: "#28a745", color: "#fff", border: "none" },
    danger:  { backgroundColor: "#e74c3c", color: "#fff", border: "none" },
    orange:  { backgroundColor: "#ff9900", color: "#fff", border: "none" }, // Amazon連携用
    gray:    { backgroundColor: "#f0f0f0", color: "#333", border: "1px solid #ddd" }, // 例: 閉じる 等
  };

  return (
    <button
      type={type}
      onClick={onClick}
      title={title}
      disabled={disabled}
      onMouseDown={() => !disabled && setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      onTouchStart={() => !disabled && setPressed(true)}
      onTouchEnd={() => setPressed(false)}
      style={{ ...baseStyle, ...(variants[variant] || variants.default), ...style }}
      {...props}
    >
      {children}
    </button>
  );
};